import { render, staticRenderFns } from "./FeedForm.vue?vue&type=template&id=0f75d974&scoped=true&"
import script from "./FeedForm.vue?vue&type=script&lang=js&"
export * from "./FeedForm.vue?vue&type=script&lang=js&"
import style0 from "./FeedForm.vue?vue&type=style&index=0&id=0f75d974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f75d974",
  null
  
)

export default component.exports